import StartPage from '../../components/pages/StartPageFlipped';
import themes from '../../themes';

export default function Startseite() {
  return <StartPage theme={themes.bohren} station={'bohren'} rotations={{ root: 270 }}/>;
}
